module.exports = __webpack_public_path__ + "assets/img/thumb-logitechworkspace-lp-lifestyle.abb64ee4.webp";